import React, { useEffect, useRef } from "react";
import "./App.css";

// import Router
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {SceneCanvas, Character} from 'ultron-ai-sdk'
// import {SceneCanvas, Character} from '../../ultron-ai-sdk/dist/index.mjs'
// import Component
import Header from "./components/Header";
import Footer from "./components/Footer";

// import Pages
import Main from "./Pages/Main";
import About from "./Pages/About";


let isChatting = false
const containerStyle = {
  width: '50%',
  height: '50%',
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: 1,
  overflow: 'hidden',
  // border: 'solid 2px red'
};
const sections = [
  {
    id: 'comm',
    message: 'At Metabrix, collaboration sparks innovation. This section showcases our strategic partners and groundbreaking alliances shaping the future of digital human experiences.'
  },
  {
    id: 'easy-custom',
    message: 'Easily customize your characters with a wide range of options like body type, hair, clothes, shoes, etc.'
  },
  {
    id: 'working',
    message: 'Here\'s how it works: first, create your character with advanced AI using a prompt or image. Customize the character and write a backstory for the conversational agent. Now you can easily simulate these characters as per your use cases.'
  },
  {
    id: 'motion-ready',
    message: 'The Characters created are fully rigged and ready for animation or using in your favirout game engines like Unity or Unreal.'
  },
  {
    id: 'emotions',
    message: 'The Characters can express emotions triggered as per your requirement.'
  },
  {
    id: 'benefits',
    message: 'We are helping to establish AI healthcare Agents, intelligent NPCs, Customer Engagement for Banking & Insurance, Seamless Integration, Personalized Conversations with AI Trainer and Revolutionizing Content Generation.'
  },
  {
    id: 'team',
    message: 'MetaBrix Lab is driven by a passionate team of innovators, creators, and visionaries committed to revolutionizing the 3D content industry.'
  },
  {
    id: 'news',
      message: 'MetaBrix Lab has been recognized in several notable industry platforms:ISF Recognition: Ranked among the top 10 award-winning startups.NASSCOM Feature: Included in the Generative AI Startup Landscape Report etc.'
  },
];

function App() {
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', function(event) {
  console.error('Error occurred:', event.message, 'at', event.filename, 'line', event.lineno, 'column', event.colno);
});
window.addEventListener('warning', function(event) {
  console.warning('Error occurred:', event.message, 'at', event.filename, 'line', event.lineno, 'column', event.colno);
});

// const loadedSections = useRef([]);
// const currentSection = useRef(null);

// const sdk = useRef(null);

const sceneCanvas = useRef(null);
const character = useRef(null);

useEffect(()=>{
  console.log('initializing...')
  if(!isChatting)
  init()
  isChatting = true


  // window.addEventListener('scroll', handleScroll);
  // handleScroll(); // Check immediately on load (in case already visible)

  // return () => {
  //   window.removeEventListener('scroll', handleScroll);
  // };
},[])

const loadedSections = useRef(new Set());
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log(entry.target.id)
          const section = sections.find((sec) => sec.id === entry.target.id);
          if (section && !loadedSections.current.has(section.id) && character?.current) {
            loadedSections.current.add(section.id);
            say(section.message);
            observer.unobserve(entry.target); // Stop observing once spoken
          }
        }
      });
    },
    { threshold: 0.2 } // Trigger when 20% of the section is visible
  );

  sections.forEach((section) => {
    const element = document.getElementById(section.id);
    if (element) observer.observe(element);
  });

  return () => observer.disconnect(); // Cleanup on unmount
}, [character.current]);


// const handleScroll = () => {
//   if(!character.current) return
//   const commSection = document.getElementById('comm');
//   const customEasySection = document.getElementById('easy-custom');
//   const workingSection = document.getElementById('working');

//   const rect1 = commSection.getBoundingClientRect();
//   const rect2 = customEasySection.getBoundingClientRect();
//   const rect3 = workingSection.getBoundingClientRect();
//   if(rect1.top < window.innerHeight && rect1.bottom >= 0 && loadedSections.current.indexOf('comm') === -1){
//     loadedSections.current.push('comm')  
//     character.current.say('At Metabrix, collaboration sparks innovation. This section showcases our strategic partners and groundbreaking alliances shaping the future of digital human experiences.')
//   }
//   if(rect2.top < window.innerHeight && rect2.bottom >= 0 && loadedSections.current.indexOf('easy-custom') === -1){
//     loadedSections.current.push('easy-custom')
//     character.current.say('Easily customize your characters with wide range options like body type, hair, clothes, shoes etc.')
    
//   }
//   if(rect3.top < window.innerHeight && rect3.bottom >= 0 && loadedSections.current.indexOf('working') === -1){
//     loadedSections.current.push('working')
//     character.current.say('Here how it works, first create your character with advanced AI using promt or image, Customise the character and write a back story for conversational agent. now you can easily simulate these character as per your use cases.')
    
//   }
//   if(rect4.top < window.innerHeight && rect4.bottom >= 0 && loadedSections.current.indexOf('motion-ready') === -1){
//     loadedSections.current.push('motion-ready')
//     character.current.say('The Characters created are fully rigged and ready for animation or using in your favirout game engines like Unity or Unreal.')    
//   }
//   if(rect3.top < window.innerHeight && rect3.bottom >= 0 && loadedSections.current.indexOf('working') === -1){
//     loadedSections.current.push('emotions')
//     character.current.say('The Characters can express emotions triggered as per your requirement.')    
//   }
//   if(rect3.top < window.innerHeight && rect3.bottom >= 0 && loadedSections.current.indexOf('working') === -1){
//     loadedSections.current.push('emotions')
//     character.current.say('The Characters can express emotions triggered as per your requirement.')    
//   }
//   if(rect3.top < window.innerHeight && rect3.bottom >= 0 && loadedSections.current.indexOf('working') === -1){
//     loadedSections.current.push('about')
//     character.current.say("At MetaBrix, we aim to build an AI-based no-code platform that simplifies 3D content creation, enabling the next generation of digital creators to produce visual content in a truly artistic and immersive way.")
    
//   }

  
// };


const avatarId = '67385bcc006f44ef72589439'
const init = async() => {
    sceneCanvas.current = new SceneCanvas('ultron-model')
    await sceneCanvas.current.init({
      avatarId: avatarId,
        config:{
            // accessToken : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2N2M3ZThiMzllNjYzMTU0OGQ1YTNiZjAiLCJlbWFpbCI6InplZXNoYW5AbWV0YWJyaXhsYWIuY29tIiwiaWF0IjoxNzQxMTU0NDgzLCJleHAiOjE3NDIwMTg0ODN9.PUt_HNpvmLqkqV6ouxT4ZjNx7kh2v4z7cP_IHt6ycd8',
            // refreshToken : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NzQ1ODkyYTY3ZjA4NGIzNjQ3ZmY2ZjciLCJpYXQiOjE3NDA0Nzk1ODYsImV4cCI6MTc0MTM0MzU4Nn0.3wsEaz2CuNidm8Ci37EWjXvsem1zadJnSdfpUmyRwPQ',
            // sessionId : "426536db-25a4-4682-9bb4-4e93530f84a0",
            apiKey: "890d540e9d04568da08eee853a4c1053"
        },
        options:{
            alwaysListen: false
        }
    })
    character.current = sceneCanvas.current.character
    // character.current.setAudioInputDevice('96996d808e614bed4409a42d4fddf28747549df7a026410bf074adad6bf8a061')            
}

const say=(text)=>{
  if(character.current){
    character.current.say(text)
  }
}

  return (
    <React.StrictMode>
      <Router>
        <Header />
          <div id="ultron-model" style={containerStyle}></div>
          <Routes>
            <Route path='/' element={<Main/>} />
            <Route path="/about" element={<About/>} />
          </Routes>
        <Footer />
      </Router>
    </React.StrictMode>
  );
}

export default App;